<template>
  <v-card flat>
    <v-card-title>
      <v-btn-toggle v-model="sendType" mandatory>
          <v-btn value="correo" v-if="canCorreo">
            <span class="hidden-sm-and-down">Correo</span><span class="hidden-md-and-up">HC</span>
          </v-btn>
          <!-- <v-btn value="sms" v-if="canSms">
            <span class="hidden-sm-and-down">SMS</span><span class="hidden-md-and-up">HS</span>
          </v-btn>
          <v-btn value="whatsapp" v-if="canWhatsapp">
            <span class="hidden-sm-and-down">Whatsapp</span><span class="hidden-md-and-up">HW</span>
          </v-btn> -->
      </v-btn-toggle>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <vuetify-table
              :headers="headers"
              :api-u-r-l="apiURL"
              :title="title"
              :back="true"
              back-u-r-l="documentos"
          >
          </vuetify-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTablePayroll';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('documents') };
  },
  components: {
      VuetifyTable,
  },
  props: {
    enterprise_id: { default: '' },
    serie: { default: '' },
    type: { default: '' },
    number: { default: '' },
  },
  watch: {
    sendType: {
      handler() {
        if (this.sendType === 'correo') {
          this.apiURL = `/api/payroll/documents/tracking-mail/${this.enterprise_id}/${this.type}/${this.number}`;
          this.title = `Historial de Correo | Documento: <b>${this.number}</b>`;
          this.headers = [
            { text: 'Correo', value: 'email', align: 'left', sortable: true },
            { text: 'Estado', value: 'estado', align: 'left', sortable: true },
            { text: 'Fecha  ', value: 'created_at', align: 'left', sortable: true },
          ];
        } else if (this.sendType === 'sms') {
          this.apiURL = `/api/payroll/documents/tracking-sms/${this.enterprise_id}/${this.type}/${this.number}`;
          this.title = `Historial de SMS | Documento: <b>${this.number}</b>`;
          this.headers = [
            { text: 'Teléfono', value: 'number', align: 'left', sortable: true },
            { text: 'Estado', value: 'estado', align: 'left', sortable: true },
            { text: 'Fecha  ', value: 'created_at', align: 'left', sortable: true },
          ];
        } else if (this.sendType === 'whatsapp') {
          this.apiURL = `/api/payroll/documents/tracking-whatsapp/${this.enterprise_id}/${this.type}/${this.number}`;
          this.title = `Historial de Whatsapp | Documento: <b>${this.number}</b>`;
          this.headers = [
            { text: 'Teléfono', value: 'number', align: 'left', sortable: true },
            { text: 'Estado', value: 'estado', align: 'left', sortable: true },
            { text: 'Fecha  ', value: 'created_at', align: 'left', sortable: true },
          ];
        }
      },
      deep: true,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Correo',
        value: 'email',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'estado',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha  ',
        value: 'created_at',
        align: 'left',
        sortable: true,
      },
    ],
    title: '',
    sendType: 'correo',
    apiURL: '',
    canCorreo: true,
    canSms: false,
    canWhatsaspp: false,
  }),
  async mounted() {
    window.axios.get(`api/enterprises/fel/${this.enterprise_id}`)
      .then((response) => {
        this.canWhatsapp = response.data.send_whatsapp;
        this.canSms = response.data.send_sms;
    });
    this.apiURL = `/api/payroll/documents/tracking-mail/${this.enterprise_id}/${this.type}/${this.number}`;
    this.title = `Historial de Correo | Documento: <b>${this.number}</b>`;
  },
};
</script>
